module.exports = __webpack_public_path__ + "img/ex-tasks_md.04cf2776.png";